import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import "react";
import { EmptyListImage, EmptySearchImage } from "@vk-hr-tek/ui/graphics";
const IMAGES = {
    search: EmptySearchImage,
    list: EmptyListImage
};
const EmptyStateImage = (t0)=>{
    const $ = c(2);
    const { mode: t1 } = t0;
    const mode = void 0 === t1 ? "list" : t1;
    const Image = IMAGES[mode];
    let t2;
    if ($[0] !== Image) {
        t2 = /*#__PURE__*/ jsx(Image, {});
        $[0] = Image;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
};
export { EmptyStateImage };
